export default function loadArcGIS() {
  // 1️⃣ #viewDiv present
  const viewDiv = document.getElementById('viewDiv');
  if (!viewDiv) {
    console.warn('⛔ #viewDiv element not fount in DOM – ArcGIS could not be loaded.');
    throw new Error('#viewDiv not found');
  }

  // 2️⃣ ArcGIS still loaded
  if (window.require && window.require.specified) {
    return Promise.resolve();
  }

  // 3️⃣ css-link added
  const cssHref = 'https://js.arcgis.com/4.29/esri/themes/light/main.css';
  if (!document.querySelector(`link[href="${cssHref}"]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssHref;
    document.head.appendChild(link);
  }

  // 4️⃣ script add
  const scriptSrc = 'https://js.arcgis.com/4.29/';
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${scriptSrc}"]`)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = scriptSrc;
    script.onload = () => {
      resolve();
    };

    script.onerror = loadError => reject(loadError);
    document.head.appendChild(script);
  });
}
